import { signal } from '@preact/signals-react'

export const utgListSignal = signal([])
export const utgListLoadedSignal = signal(false)
export const utgListErrorSignal = signal(null)

export const utgSignal = signal({})
export const utgLoadedSignal = signal(false)
export const utgErrorSignal = signal(null)

export const componentSignal = signal({})
export const componentLoadedSignal = signal(false)
export const componentErrorSignal = signal(null)

export const utgTaskListSignal = signal([])
export const utgTaskListLoadedSignal = signal(false)
export const utgTaskListErrorSignal = signal(null)

export const utgDeviceListSignal = signal([])
export const utgDeviceListLoadedSignal = signal(false)
export const utgDeviceListErrorSignal = signal(null)